import Box from '@material-ui/core/Box'
import Divider from '@material-ui/core/Divider'
import Drawer from '@material-ui/core/Drawer'
import Hidden from '@material-ui/core/Hidden'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListSubheader from '@material-ui/core/ListSubheader'
import MenuItem from '@material-ui/core/MenuItem'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'
import CakeIcon from '@material-ui/icons/Cake'
import EventIcon from '@material-ui/icons/Event'
import HomeIcon from '@material-ui/icons/Home'
import ListIcon from '@material-ui/icons/List'
import PeopleIcon from '@material-ui/icons/People'
import SwapHorizIcon from '@material-ui/icons/SwapHoriz'
import AccountBalanceIcon from '@material-ui/icons/AccountBalance'
import { push } from 'connected-react-router'
import React from 'react'

import { useDispatch } from 'react-redux'
import useTypedSelector from '../hooks/useTypedSelector'
import PAGES from '../pages'
import { DrawerActionTypes } from '../store/drawer/drawerTypes'
import { changeChurch } from '../store/session/sessionActions'

const drawerWidth = 250

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  imgLogo: {
    width: 50,
    marginLeft: theme.spacing(-2),
  },
  drawer: {
    [theme.breakpoints.up('lg')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  drawerPaper: {
    width: drawerWidth,
  },
}))

export default function Sidebar() {
  const classes = useStyles()
  const { pathname, isDrawerMobileOpen, churches, selectedChurch, roles } =
    useTypedSelector(({ router, drawerState, sessionState }) => ({
      pathname: router.location.pathname,
      isDrawerMobileOpen: drawerState.isMobileOpen,
      churches: sessionState.user?.churches || [],
      selectedChurch:
        sessionState.user?.churches[sessionState.selectedChurchIndex] || null,
      roles: sessionState.user?.roles || [],
    }))
  const dispatch = useDispatch()
  const currentPage = PAGES.find(
    (page) => page.path.split('/')[1] === pathname.split('/')[1]
  )

  const onChangeChurch = (e: any) => {
    dispatch({ type: DrawerActionTypes.CLOSE_MOBILE_DRAWER })
    dispatch(changeChurch(e.target.value))
  }

  const onClickMenuItem = (path: string) => () => {
    dispatch({ type: DrawerActionTypes.CLOSE_MOBILE_DRAWER })
    dispatch(push(path))
  }

 



  const drawer = (
    <div>
      <Toolbar>
        <img src="/logo.png" className={classes.imgLogo} alt="logo" />
        <Typography noWrap variant="h6" color="primary">
          <p style={{ fontWeight: 300 }}> Igreja nas nuvens </p>
        </Typography>
      </Toolbar>
      <Divider />
      <Box p={1}>
        <TextField
          select
          fullWidth
          value={selectedChurch?.id || ''}
          onChange={onChangeChurch}
        >
          {churches.map((church: any) => (
            <MenuItem
              key={church.id}
              value={church.id}
              children={church.name}
            />
          ))}
        </TextField>
      </Box>
      <List>
        <ListItem
          button
          onClick={onClickMenuItem('/')}
          selected={!!currentPage && currentPage.path === '/'}
        >
          <ListItemIcon>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary="Painel" />
        </ListItem>
        {roles.includes('people') && (
          <>
            <ListSubheader children="Secretaria" />

            <ListItem
              button
              onClick={onClickMenuItem('/membros')}
              selected={!!currentPage && currentPage.path === '/membros'}
              disabled={!roles.includes('people')}
            >
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Membros" />
            </ListItem>
            <ListItem
              button
              onClick={onClickMenuItem('/agenda')}
              selected={!!currentPage && currentPage.path === '/agenda'}
              disabled={!roles.includes('people')}
            >
              <ListItemIcon>
                <EventIcon />
              </ListItemIcon>
              <ListItemText primary="Agenda" />
            </ListItem>
            <ListItem
              button
              onClick={onClickMenuItem('/birthday')}
              selected={!!currentPage && currentPage.path === '/birthday'}
              disabled={!roles.includes('people')}
            >
              <ListItemIcon>
                <CakeIcon />
              </ListItemIcon>
              <ListItemText primary="Aniversariantes" />
            </ListItem>
          </>
        )}
        {roles.includes('transactions') && (
          <>
            <Divider />
            <ListSubheader children="Tesouraria" />

            <ListItem
              button
              onClick={onClickMenuItem('/lancamentos')}
              selected={!!currentPage && currentPage.path === '/lancamentos'}
              disabled={!roles.includes('transactions')}
            >
              <ListItemIcon>
                <AttachMoneyIcon />
              </ListItemIcon>
              <ListItemText primary="Lançamentos" />
            </ListItem>

            <ListItem
              button
              onClick={onClickMenuItem('/transferencias')}
              selected={!!currentPage && currentPage.path === '/transferencias'}
              disabled={!roles.includes('transactions')}
            >
              <ListItemIcon>
                <SwapHorizIcon />
              </ListItemIcon>
              <ListItemText primary="Transferências" />
            </ListItem>
            <ListItem
              button
              onClick={onClickMenuItem('/patrimony')}
              selected={!!currentPage && currentPage.path === '/patrimony'}
              disabled={!roles.includes('transactions')}
            >
              <ListItemIcon>
                <AccountBalanceIcon />
              </ListItemIcon>
              <ListItemText primary="Patrimônio" />
            </ListItem>

            <ListItem
              button
              onClick={onClickMenuItem('/categorias')}
              selected={!!currentPage && currentPage.path === '/categorias'}
              disabled={!roles.includes('transactions')}
            >
              <ListItemIcon>
                <ListIcon />
              </ListItemIcon>
              <ListItemText primary="Categorias" />
            </ListItem>

            <Divider />
            <ListSubheader children="Mensalidade" />

            <ListItem
              button
              onClick={onClickMenuItem('/payment')}
              selected={!!currentPage && currentPage.path === '/payment'}
              disabled={!roles.includes('transactions')}
            >
              <ListItemIcon>
                <AddShoppingCartIcon />
              </ListItemIcon>
              <ListItemText primary="Pagamentos" />
            </ListItem>
          </>
        )}
      </List>
    </div>
  )

  return (
    <nav className={classes.drawer}>
      <Hidden lgUp implementation="css">
        <Drawer
          variant="temporary"
          open={isDrawerMobileOpen}
          onClose={() =>
            dispatch({ type: DrawerActionTypes.CLOSE_MOBILE_DRAWER })
          }
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {drawer}
        </Drawer>
      </Hidden>
      <Hidden mdDown implementation="css">
        <Drawer
          classes={{
            paper: classes.drawerPaper,
          }}
          variant="permanent"
          open
        >
          {drawer}
        </Drawer>
      </Hidden>
    </nav>
  )
}
